import type { ReactNode } from 'react';

export interface TwoLineProps {
    /** The human label (text, 1rem). */
    primary: ReactNode;
    /** The path / id / e-mail under it (text-3, 12 px). */
    secondary?: ReactNode;
    /** Secondary line in mono (paths, ids). Default `true`. */
    mono?: boolean;
}

/** The "human label + mono path / id" cell of the boards (`ds.css` "two-line cell"). */
export function TwoLine(props: TwoLineProps) {
    const mono = props.mono ?? true;
    return (
        <span className="ark-two-line">
            <span className="ark-two-line-primary">{props.primary}</span>
            {props.secondary !== undefined && props.secondary !== null && props.secondary !== ''
                ? <span className={mono ? 'ark-two-line-secondary is-mono' : 'ark-two-line-secondary'}>{props.secondary}</span>
                : null}
        </span>
    );
}
